<template>
  <div class="booking-step-header">
    <div class="booking-step-header__text">
      <span v-if="displayStep" class="font-danjunghae booking-step-header__step">{{ displayStep }}</span>
      <span class="booking-step-header__title">
        <slot name="title">{{ title }}</slot>
      </span>
    </div>
    <div v-if="hasAddon" class="booking-step-header__addon">
      <slot name="addon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "BookingStepHeader",
  props: {
    step: {
      type: [Number, String],
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayStep() {
      const raw = String(this.step ?? "").trim()
      if (!raw) return ""
      if (/^step/i.test(raw)) {
        return raw.toUpperCase()
      }
      const numeric = Number(raw)
      if (!Number.isNaN(numeric)) {
        return `STEP.${numeric}`
      }
      return `STEP.${raw}`
    },
    hasAddon() {
      return !!this.$slots.addon
    },
  },
}
</script>

<style scoped>
.booking-step-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.booking-step-header__text {
  display: flex;
  align-items: baseline;
  column-gap: 12px;
  color: #a15a67;
}

.booking-step-header__step {
  font-size: 28px;
  letter-spacing: 0.05em;
}

.booking-step-header__title {
  font-size: 16px;
  font-weight: 600;
}

.booking-step-header__addon {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
</style>
